import React, {
    Fragment,
    useContext,
    useEffect,
    useMemo,
    useCallback,
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import Traductor from '../Traductor';
import Globals from '../../Globals';
import { UserContext } from '../../contexts/UserContext';
import { VehiclesContext } from '../../contexts/VehiclesContext';

import * as filtersActions from '../../redux/actions/filters';
import { filterFavorite, filterBidden } from '../../constants/Filters';

import usePermissions from 'hooks/usePermissions';
import { READONLY_PERMISSION } from 'constants/Permissions';

const MegaMenu = ({
    history,
    visible,
    setNewStatusMegaMenu,
    reduxFilters,
    setFilters: setReduxFilters,
}) => {
    const t = useMemo(() => new Traductor(), []);
    const { checkPermission } = usePermissions();
    const { user } = useContext(UserContext);
    // const { setShowSimulationsRVO } = useContext(VehiclesContext);

    const closeMegaMenu = useCallback(() => {
        setNewStatusMegaMenu(false);
    }, [setNewStatusMegaMenu]);

    const checkClickInsideMegaMenu = useCallback(
        e => {
            const element = e.target;
            const isInsideMenu = element.closest('.js-mega-menu');
            const isBurgerTrigger = element.closest('.js-mega-menu-trigger');

            if (!isInsideMenu && !isBurgerTrigger) {
                closeMegaMenu();
            }
        },
        [closeMegaMenu]
    );

    useEffect(() => {
        if (visible) {
            document.addEventListener('click', checkClickInsideMegaMenu);
        } else {
            document.removeEventListener('click', checkClickInsideMegaMenu);
        }
    }, [checkClickInsideMegaMenu, visible]);

    const onClickGoToListVehicles = () => {
        setReduxFilters({
            ...reduxFilters[Globals.APPLICATION_PATH.AUCTION].initial,
            [filterBidden]: false,
            [filterFavorite]: false,
            route: [Globals.APPLICATION_PATH.AUCTION],
        });
        if (history.location.pathname !== Globals.APPLICATION_PATH.AUCTION) {
            history.push(Globals.APPLICATION_PATH.AUCTION);
            closeMegaMenu();
        } else {
            history.replace({
                pathname: Globals.APPLICATION_PATH.AUCTION,
            });
        }
    };

    const onClickGoTodealerReceptor = () => {
        let route = Globals.APPLICATION_PATH.RECEIVINGDEALER;
        if (history.location.pathname != route) {
            setReduxFilters({
                ...reduxFilters[Globals.APPLICATION_PATH.RECEIVINGDEALER]
                    .initial,
                route: Globals.APPLICATION_PATH.RECEIVINGDEALER,
            });
            history.push(route);
            closeMegaMenu();
        }
    };

    const onClickGoToProfile = type => {
        history.push(Globals.APPLICATION_PATH.PROFILE + '/' + type);
        closeMegaMenu();
    };

    const onClickGoToAdjudications = () => {
        setReduxFilters({
            ...reduxFilters[Globals.APPLICATION_PATH.ADJUDICATIONS].initial,
            route: [Globals.APPLICATION_PATH.ADJUDICATIONS],
        });
        history.push(Globals.APPLICATION_PATH.ADJUDICATIONS);
        closeMegaMenu();
    };

    const onClickGoToAdjudicationsVWR = () => {
        setReduxFilters({
            ...reduxFilters[Globals.APPLICATION_PATH.SOLDVWR].initial,
            route: [Globals.APPLICATION_PATH.SOLDVWR],
        });
        history.push(Globals.APPLICATION_PATH.SOLDVWR);
        closeMegaMenu();
    };

    const onClickGoToMyBids = () => {
        setReduxFilters({
            ...reduxFilters[Globals.APPLICATION_PATH.AUCTION].initial,
            [filterBidden]: true,
            route: [Globals.APPLICATION_PATH.AUCTION],
        });
        history.replace({
            pathname: Globals.APPLICATION_PATH.AUCTION,
        });
        closeMegaMenu();
    };

    const onClickGoToMyBatches = () => {
        history.push({
            pathname: Globals.APPLICATION_PATH.BATCHES,
        });
        closeMegaMenu();
    };

    const onClickGoToFavorites = () => {
        setReduxFilters({
            ...reduxFilters[Globals.APPLICATION_PATH.AUCTION].initial,
            [filterFavorite]: true,
            route: [Globals.APPLICATION_PATH.AUCTION],
        });
        history.replace({
            pathname: Globals.APPLICATION_PATH.AUCTION,
        });
        closeMegaMenu();
    };

    const onClickGoToRentingRedRac = (route, filters) => {
        if (history.location.pathname !== route) {
            if (filters) {
                setReduxFilters({
                    ...reduxFilters[route].initial,
                    ...filters,
                    route,
                });
            }
            history.push(route);
            closeMegaMenu();
        }
    };

    const onClickGoToExpirationMatrix = () => {
        history.push(Globals.APPLICATION_PATH.HOME);
        closeMegaMenu();
    };

    const onClickGoToMetricasHuerto = () => {
        history.push(Globals.APPLICATION_PATH.METRICASHUERTO);
        closeMegaMenu();
    };
    const onClickGoToTextoLandingHuerto = () => {
        history.push(Globals.APPLICATION_PATH.TEXTOLANDINGHUERTO);
        closeMegaMenu();
    };

    const onClickGoToSearchTicket = () => {
        const route = Globals.APPLICATION_PATH.SEARCH_TICKET;
        if (history.location.pathname !== route) {
            history.push(route);
            closeMegaMenu();
        }
    };

    const redirectToVehicleStatusPage = () => {
        const route = Globals.APPLICATION_PATH.SEARCH_VEHICLE_STATUS;
        if (history.location.pathname !== route) {
            history.push(route);
            closeMegaMenu();
        }
    };

    return (
        <div className="o-page-wrap o-page-wrap--xsmall c-mega-menu__outer-wrap  u-ph-none@s">
            <div
                id="js-mega-menu"
                className={`js-mega-menu-wrap  c-mega-menu__inner-wrap js-is-loaded ${
                    visible ? '' : 'is-closed'
                }`}
            >
                <nav className={`js-mega-menu  c-mega-menu js-is-loaded`}>
                    <ul className="c-mega-menu__list  c-mega-menu__list--level-one  u-mb">
                        {checkPermission(
                            'CNST_GESTION_COMERCIAL_CONCESIONARIO'
                        ) ? (
                            <Fragment>
                                <li className="c-mega-menu__list-title">
                                    {t.getTraduction('Subastas')}
                                </li>
                                <li>
                                    <a
                                        onClick={() =>
                                            onClickGoToListVehicles()
                                        }
                                        className="c-mega-menu__link  c-mega-menu__link--level-one"
                                    >
                                        {t.getTraduction('ActiveVehicles')}
                                    </a>
                                </li>
                                {!checkPermission(READONLY_PERMISSION) && (
                                    <li>
                                        <a
                                            onClick={() => onClickGoToMyBids()}
                                            className="c-mega-menu__link  c-mega-menu__link--level-one"
                                        >
                                            {t.getTraduction('MyBids')}
                                        </a>
                                    </li>
                                )}
                                {!checkPermission(READONLY_PERMISSION) && (
                                    <li>
                                        <a
                                            onClick={onClickGoToMyBatches}
                                            className="c-mega-menu__link  c-mega-menu__link--level-one"
                                        >
                                            {t.getTraduction('MyBatches')}
                                        </a>
                                    </li>
                                )}
                                {!checkPermission(READONLY_PERMISSION) && (
                                    <li>
                                        <a
                                            onClick={onClickGoToSearchTicket}
                                            className="c-mega-menu__link  c-mega-menu__link--level-one"
                                        >
                                            {t.getTraduction(
                                                'TicketsManagement'
                                            )}
                                        </a>
                                    </li>
                                )}
                                {user?.data?.Profile === 12 && (
                                    <li>
                                        <a
                                            onClick={
                                                redirectToVehicleStatusPage
                                            }
                                            className="c-mega-menu__link  c-mega-menu__link--level-one"
                                        >
                                            {t.getTraduction(
                                                'CheckVehicleStatus'
                                            )}
                                        </a>
                                    </li>
                                )}
                                {!checkPermission(READONLY_PERMISSION) &&
                                user?.data?.Profile === 12 ? (
                                    <li>
                                        <a
                                            onClick={() =>
                                                onClickGoTodealerReceptor()
                                            }
                                            className="c-mega-menu__link  c-mega-menu__link--level-one"
                                        >
                                            {t.getTraduction(
                                                'PurchaseOptionReceiverDealer'
                                            )}
                                        </a>
                                    </li>
                                ) : null}
                                {!checkPermission(READONLY_PERMISSION) && (
                                    <>
                                        <li>
                                            <a
                                                onClick={() =>
                                                    onClickGoToRentingRedRac(
                                                        Globals.APPLICATION_PATH
                                                            .RENTING_RED_RAC,
                                                        {}
                                                    )
                                                }
                                                className="c-mega-menu__link  c-mega-menu__link--level-one"
                                            >
                                                {t.getTraduction(
                                                    'RentingPurchaseOption'
                                                )}
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                onClick={() =>
                                                    onClickGoToAdjudications()
                                                }
                                                className="c-mega-menu__link  c-mega-menu__link--level-one"
                                            >
                                                {t.getTraduction(
                                                    'BuyedVehicles'
                                                )}
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                onClick={() =>
                                                    onClickGoToAdjudicationsVWR()
                                                }
                                                className="c-mega-menu__link  c-mega-menu__link--level-one"
                                            >
                                                {t.getTraduction(
                                                    'SoldVehiclesVWR'
                                                )}
                                            </a>
                                        </li>
                                    </>
                                )}
                                {/* <li>
                                    <a
                                        onClick={() =>
                                            setShowSimulationsRVO(true)
                                        }
                                        className="c-mega-menu__link  c-mega-menu__link--level-one"
                                    >
                                        {t.getTraduction(
                                            'RentingVOSimulationFinder'
                                        )}
                                    </a>
                                </li> */}
                                <li>
                                    <a
                                        onClick={() => onClickGoToFavorites()}
                                        className="c-mega-menu__link  c-mega-menu__link--level-one"
                                    >
                                        {t.getTraduction('Favourits')}
                                    </a>
                                </li>
                                <li>
                                    <a
                                        onClick={() =>
                                            onClickGoToProfile('preferences')
                                        }
                                        className="c-mega-menu__link  c-mega-menu__link--level-one"
                                    >
                                        {t.getTraduction('Preferencias')}
                                    </a>
                                </li>
                            </Fragment>
                        ) : null}
                        {checkPermission(
                            'CNST_REMAMOBILE_VER_VENCIMIENTO_CONCESIONARIO'
                        ) ? (
                            <Fragment>
                                <li className="c-mega-menu__list-title">
                                    {t.getTraduction('ExpirationManagement')}
                                </li>
                                <li>
                                    <a
                                        onClick={() =>
                                            onClickGoToExpirationMatrix()
                                        }
                                        className="c-mega-menu__link  c-mega-menu__link--level-one"
                                    >
                                        {t.getTraduction('ExpirationMatrix')}
                                    </a>
                                </li>
                            </Fragment>
                        ) : null}
                        {checkPermission('CNST_VER_METRICAS_HUERTO') ? (
                            <Fragment>
                                <li>
                                    <a
                                        onClick={() =>
                                            onClickGoToMetricasHuerto()
                                        }
                                        className="c-mega-menu__link  c-mega-menu__link--level-one"
                                    >
                                        Metricas Huerto
                                    </a>
                                </li>
                            </Fragment>
                        ) : null}
                        {checkPermission('CNST_VER_METRICAS_HUERTO') ? (
                            <Fragment>
                                <li>
                                    <a
                                        onClick={() =>
                                            onClickGoToTextoLandingHuerto()
                                        }
                                        className="c-mega-menu__link  c-mega-menu__link--level-one"
                                    >
                                        Texto Landing Huerto
                                    </a>
                                </li>
                            </Fragment>
                        ) : null}
                    </ul>
                    {checkPermission('CNST_GESTION_COMERCIAL_CONCESIONARIO') ? (
                        <Fragment>
                            <ul className="c-mega-menu__list  c-mega-menu__list--level-one">
                                <li>
                                    <a
                                        className="c-mega-menu__link  c-mega-menu__link--level-one"
                                        onClick={() =>
                                            history.push(
                                                Globals.APPLICATION_PATH.FAQS
                                            )
                                        }
                                    >
                                        <span className="o-media  o-media--small  o-media--middle">
                                            <span className="o-media__img">
                                                <i className="c-mega-menu__icon  c-icon  c-icon--xsmall  c-icon--[control-comments]"></i>
                                            </span>
                                            <span className="o-media__body">
                                                {t.getTraduction('Faqs')}
                                            </span>
                                        </span>
                                    </a>
                                </li>
                            </ul>
                            <ul className="c-mega-menu__list  c-mega-menu__list--level-one">
                                <li>
                                    <a
                                        className="c-mega-menu__link  c-mega-menu__link--level-one"
                                        onClick={() =>
                                            history.push(
                                                Globals.APPLICATION_PATH.CONTACT
                                            )
                                        }
                                    >
                                        <span className="o-media  o-media--small  o-media--middle">
                                            <span className="o-media__img">
                                                <i className="c-mega-menu__icon  c-icon  c-icon--xsmall  c-icon--[control-magazine]"></i>
                                            </span>
                                            <span className="o-media__body">
                                                {t.getTraduction('Contact')}
                                            </span>
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </Fragment>
                    ) : null}
                </nav>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    reduxFilters: state.filters,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    ...bindActionCreators({ ...filtersActions }, dispatch),
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(MegaMenu)
);
